module.exports = __webpack_public_path__ + "static/Steve-Urkel-4a1689c0e5a81510585db7d68287a329.png";